// extracted by mini-css-extract-plugin
export default {"deleteFeed":"styles_deleteFeed__XnVwQ"};